import { baseApi, defaultQueryFreshness } from "./baseApi";
import type { MyMatchesResponse } from "../../api/matches";

export const matchesApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getMyMatches: builder.query<MyMatchesResponse, void>({
      query: () => ({ url: "/matches/me", method: "GET" }),
      ...defaultQueryFreshness,
    }),
  }),
});

export const { useGetMyMatchesQuery } = matchesApi;
